// 在 main.js 文件的最顶部，所有 import 语句之前添加
if (typeof window !== 'undefined') {
  // 重写 ResizeObserver 来避免循环限制错误
  const ResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends ResizeObserver {
    constructor(callback) {
      super(entries => {
        // 使用 setTimeout 来避免 ResizeObserver 循环限制
        setTimeout(() => callback(entries), 0);
      });
    }
  };
}

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import tools from "@/utils/http";
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import '@fortawesome/fontawesome-free/css/all.css';
import GlobalComponents from './components/index'; // 导入插件

const app = createApp(App);

app.use(router); // 使用路由器实例
app.use(ElementPlus);
app.use(GlobalComponents);
app.use(Toast, {
    transition: "Vue-Toastification__bounce",
    maxToasts: 20,
    newestOnTop: true
  });

app.mount('#app')
app.config.globalProperties.$tools = tools; //设置工具类
